/**
 * Created by DynamicDog on 2016-12-03.
 *
 * The main application class/component
 */
import {Component, NgZone, EventEmitter,Output} from '@angular/core';
import {EtikettService} from "./services/etikett.service";
import {Location} from '@angular/common';
import {TranslateService} from "./services/translate.service";
var $ = window['$'];

@Component({
    selector: 'my-app',
    template: ` 
                <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
                <meta http-equiv="Pragma" content="no-cache">
                <meta http-equiv="Expires" content="0"> <busy-screen></busy-screen>
                <div *ngIf="translationsLoaded" scroll="no" class="body-content selected-{{etikettService.shape}}">
                    <intro-view></intro-view>
                    <select-view></select-view>                    
                    <div *ngIf="etikettService.mode==='create' && etikettService.project.etiketter.length > 0">
                        <etikett-view></etikett-view>
                        <print-view></print-view>
                    </div>

                    <app-footer></app-footer>
                    
                </div>     
                           
                `
})

export class AppComponent {
    private translationsLoaded = false;
    private langQuery:string = '';
    @Output() loaded: EventEmitter<any> = new EventEmitter();
    constructor(private etikettService:EtikettService, private location:Location, private zone:NgZone,private translate:TranslateService) {
        var query = this.queryStringToJSON(window.location['search']);
        var uuid = query['id'];
        var pdf = query['pdf'];
        var lang = query['lang'];
        var _this = this;

        if(lang) {
            _this.langQuery = '&lang='+lang;
            translate.language = lang;
        }
        this.translationsLoaded = false;
        // Start by loading translations
        this.etikettService.getLabelCount().then(function() {
        translate.loadTranslation().then(function() {
            _this.translationsLoaded = true;
            if(window.location['pathname']) {
                _this.etikettService.server = window.location['pathname'].substring(0, window.location['pathname'].lastIndexOf("/") + 1);
            }
            if(window.location['origin']) {
                _this.etikettService.host = window.location['origin'];
            }
            if(pdf) {
                window.open(_this.etikettService.server+"projects/"+pdf+".pdf","_self");
            } else {
                _this.initProject(uuid);
            }
        },function(err) {

        })
    })
    }

    private createProject(uuid?:string) {

        return this.etikettService.createEtikettProject(uuid);
    }

    // Try to load the images and 
    private loadProjectShape() {
        this.etikettService.getLabelCount();
        this.loaded.emit(null);
    }

    private initProject(uuid?:string) : void {
        var _this = this;
        // If we have an uuid, try to load it.
        if(uuid) {
            _this.etikettService.loadEtikettProject(uuid).then((val)=>_this.loadProjectShape(),(err)=>_this.createProject(uuid));
        } else {
            var uuid = _this.createProject();
            window.open(_this.etikettService.server+_this.etikettService.aspxFile+"?id=" + uuid+_this.langQuery, "_self");
        }
    }


    // Convert a url query string to a json object
    private queryStringToJSON(search:string):any {
        if(!search)
            return {};
        var pairs = search.slice(1).split('&');
        var keyValue: any;
        var result = {};
        pairs.forEach(function(pair) {
            keyValue = pair.split('=');
            result[keyValue[0]] = decodeURIComponent(keyValue[1] || '');
        });

        return JSON.parse(JSON.stringify(result));
    }

}



// WEBPACK FOOTER //
// ./app/app.component.ts